import { render, staticRenderFns } from "./topic.vue?vue&type=template&id=450223ec&scoped=true&"
import script from "./topic.vue?vue&type=script&lang=js&"
export * from "./topic.vue?vue&type=script&lang=js&"
import style0 from "./topic.vue?vue&type=style&index=0&id=450223ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450223ec",
  null
  
)

export default component.exports